<!-- 关于我们 -->
<template>
  <div class="template-container">
    <div class="container-main">
      <div class="main-top-box">
        <div class="img-top-back"><div class="back-text">{{ $t("about_company.name-1") }}</div></div>
        <img class="img-top" src="/static/images/industry/hw600/section6.png" />
      </div>
      <div>
        <div class="main-text1">{{ $t("about_index.text12") }} > {{ $t("about_company.name-1") }}</div>
        <div class="main-content-top-box">
          <div class="main-content-top-left">
            <div class="left-title">{{ $t("about_company.name") }}</div>
            <div class="left-text">
              {{ $t("about_company.intro") }}
            </div>
            <div class="left-line"></div>
            <div class="left-flex">
              <div class="left-flex-item">
                <img
                  class="flex-item-img"
                  src="/static/images/industry/hw16v/check.png"
                />
                <div class="flex-item-name">{{ $t("about_company.title1") }}</div>
                <div class="flex-item-text">
                  {{ $t("about_company.desc1") }}
                </div>
              </div>
              <div class="left-flex-item" style="margin: 0px 60px 0px 60px;">
                <img
                  class="flex-item-img"
                  src="/static/images/industry/hw16v/check.png"
                />
                <div class="flex-item-name">{{ $t("about_company.title2") }}</div>
                <div class="flex-item-text">
                  {{ $t("about_company.desc2") }}
                </div>
              </div>
              <div class="left-flex-item">
                <img
                  class="flex-item-img"
                  src="/static/images/industry/hw16v/check.png"
                />
                <div class="flex-item-name">{{ $t("about_company.title3") }}</div>
                <div class="flex-item-text">
                  {{ $t("about_company.desc3") }}
                </div>
              </div>
            </div>
          </div>
          <img class="img-totop" src="/static/images/about/company/toptop2.png" />
        </div>
      </div>
      <div class="main-center-box">
        <div class="main-center-title">{{ $t("about_company.title4") }}</div>
        <div class="main-center-title">{{ $t("about_company.title5") }}</div>
      </div>
      <div class="main-bottom-text">
        {{ $t("about_company.desc4") }}<span style="color: #111"
          >{{ $t("about_company.desc5") }}</span
        >{{ $t("about_company.desc6") }}
      </div>
      <img
        class="main-bottom-img"
        :src="$i18n.locale=='zh_CN'?'/static/images/about/company/banner1_cn.png':'/static/images/about/company/banner1_en.png'"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang='stylus' scoped>
.template-container {
  width: 100%;
  max-width: 1920px;
  min-width :1296px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  background: #fff;

  .container-main {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .main-top-box {
      width: 100%;
      max-width: 1920px;
      max-height: 600px;

      .img-top {
        object-fit: cover;
        width: 100%;
        max-width: 1920px;
        height: 600px;
        background: rgba(22, 80, 154, 0.8);
      }

      .img-top-back {
        z-index: 10;
        opacity: 1;
        position: absolute;
        width: 100%;
        max-width: 1920px;
        min-width :1296px;
        height: 600px;
        background: linear-gradient(180deg, rgba(22, 80, 154, 0.8) 0%, rgba(100, 138, 188, 0.4) 99%);
        opacity: 0.9;
        text-align: center;
        font-size: 34px;
        font-weight: 500;
        color: #FFFFFF;

        .back-text {
          margin-top: 327px;
        }
      }

      .img-text {
        height: 144px;
      }
    }

    .main-text1 {
      margin-top: 20px;
      font-size: 12px;
      font-weight: 500;
      line-height: 29px;
      color: #3D3D3D;
    }

    .main-content-top-box {
      margin-top: 34px;
      width: 1280px;
      height: 626px;
      .img-totop{
        margin-top: 50px;
        height: 100%
        max-width: 100%;
        object-fit: contain;
      }

      .main-content-top-left {
        position: absolute;
        width: 760px;

        .left-title {
          margin-top: 65px;
          font-size: 34px;
          font-weight: 500;
          line-height: 79px;
          color: #1E5295;
        }

        .left-text {
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          height: 90px;
          color: #666666;
        }

        .left-line {
          width: 760px;
          height: 1px;
          background: #D8D8D8;
        }

        .left-flex {
          display: flex;
          margin-top: 26px;

          .left-flex-item {
            flex: 1;

            .flex-item-img {
              width: 20px;
              height: 20px;
            }

            .flex-item-name {
              font-size: 20px;
              font-weight: 500;
              line-height: 36px;
              height: 120px;
              color: #1E5295;
            }

            .flex-item-text {
              font-size: 16px;
              font-weight: 500;
              line-height: 24px;
              color: #666666;
            }
          }
        }
      }
    }

    .main-center-box {
      margin-top: 90px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 1920px;
      height: 220px;
      background: #1E5295;

      .main-center-title {
        font-size: 24px;
        font-weight: 500;
        line-height: 36px;
        text-align: center;
        color: #FFFFFF;
      }

      .main-center-text {
        margin-top: 20px;
        padding-left: 39px;
        padding-right: 4px;
        font-size: 16px;
        font-weight: 500;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 44px;
        background: #007BE7;

        .main-center-img {
          width: 40px;
          height: 40px;
        }
      }
    }

    .main-bottom-text {
      margin-top: 109px;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      text-align: center;
      color: #666666;
      width: 783px;
    }

    .main-bottom-img {
      width: 918px;
      height: 671px;
      margin-top: 42px;
      margin-bottom: 31px;
    }
  }
}



// 移动端
@media all and (min-width: 320px) and (max-width: 768px) {
  .template-container {
    min-width :80px;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    overflow: hidden;
    box-sizing: border-box;
    background: #fff;
  
    .container-main {
   
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
  
      .main-top-box {
        width: 100%;
        max-width: 100%;
        max-height: 300px;
  
        .img-top {
          object-fit: cover;
          width: 100%;
          max-width: 100%;
          height: 300px;
          background: rgba(22, 80, 154, 0.8);
        }
  
        .img-top-back {
          z-index: 10;
          opacity: 1;
          position: absolute;
          width: 100%;
          max-width: 100%;
          min-width :80%;
          height: 300px;
          background: linear-gradient(180deg, rgba(22, 80, 154, 0.8) 0%, rgba(100, 138, 188, 0.4) 99%);
          opacity: 0.9;
          text-align: center;
          font-size: 34px;
          font-weight: 500;
          color: #FFFFFF;
  
          .back-text {
            margin-top: 127px;
          }
        }
  
        .img-text {
          height: 144px;
        }
      }
  
      .main-text1 {
        width: 90%;
        padding: 0px 5% 0px 5%;
        margin-top: 20px;
        font-size: 12px;
        font-weight: 500;
        line-height: 29px;
        color: #3D3D3D;
      }
  
      .main-content-top-box {
        margin-top: 34px;
        width: 100%;
       
        .img-totop{
         opacity :0;
          max-width: 100%;
          object-fit: contain;
        }
  
        .main-content-top-left {
          position: absolute;
          width: 90%;
          padding: 0px 5% 0px 5%;
  
          .left-title {
            margin-top: 25px;
            font-size: 34px;
            font-weight: 500;
            line-height: 79px;
            color: #1E5295;
          }
  
          .left-text {
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
            color: #666666;
          }
  
          .left-line {
            width: 100%;
            height: 1px;
            background: #D8D8D8;
          }
  
          .left-flex {
            display: flex;
            margin-top: 26px;
  
            .left-flex-item {
              flex: 1;
  
              .flex-item-img {
                width: 20px;
                height: 20px;
              }
  
              .flex-item-name {
                font-size: 14px;
                font-weight: 500;
                line-height: 16px;
                height: 120px;
                color: #1E5295;
              }
  
              .flex-item-text {
                font-size: 12px;
                font-weight: 500;
                line-height: 14px;
                color: #666666;
              }
            }
          }
        }
      }
  
      .main-center-box {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 220px;
        background: #1E5295;
  
        .main-center-title {
          font-size: 24px;
          font-weight: 500;
          line-height: 36px;
          text-align: center;
          color: #FFFFFF;
        }
  
        .main-center-text {
          margin-top: 20px;
          padding-left: 39px;
          padding-right: 4px;
          font-size: 16px;
          font-weight: 500;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 44px;
          background: #007BE7;
  
          .main-center-img {
            width: 40px;
            height: 40px;
          }
        }
      }
  
      .main-bottom-text {
        margin-top: 109px;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
        color: #666666;
        width: 90%;
      }
  
      .main-bottom-img {
        width: 100%;
        height: 60%;
        margin-top: 42px;
        margin-bottom: 31px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/about/company.vue